import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getDb } from "../../../util/Constants";
import { collection, addDoc } from "firebase/firestore";
import Swal from "sweetalert2";

export default function AddMiniGame10Modal({
  isOpen,
  toggle,
  onQuestionAdded,
}) {
  const [correctSequence, setCorrectSequence] = useState([]);
  const [wrongSequence, setWrongSequence] = useState([]);
  const [loading, setLoading] = useState(false);

  const resetFields = () => {
    setCorrectSequence([]);
    setWrongSequence([]);
  };

  const handleSubmit = async () => {
    const correct = correctSequence
      .map((v) => v.trim())
      .filter((v) => v !== "" && !isNaN(Number(v)))
      .map(Number);
    const wrong = wrongSequence
      .map((v) => v.trim())
      .filter((v) => v !== "" && !isNaN(Number(v)))
      .map(Number);

    if (!correct.length || !wrong.length) {
      Swal.fire("Error", "Please enter both sequences.", "error");
      return;
    }

    setLoading(true);
    try {
      await addDoc(collection(getDb(), "questions"), {
        miniGame: "Mini 10",
        correctSequence: correct,
        wrongSequence: wrong,
      });
      Swal.fire("Success", "Question added!", "success");
      resetFields();
      toggle();
      if (onQuestionAdded) onQuestionAdded();
    } catch (error) {
      Swal.fire("Error", "Failed to add question.", "error");
    }
    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="sm">
      <ModalHeader toggle={toggle}>Add MiniGame 10 Question</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Correct Sequence (one number per line)</Label>
          <Input
            type="textarea"
            value={correctSequence.join("\n")}
            onChange={(e) => setCorrectSequence(e.target.value.split("\n"))}
            rows={5}
            placeholder="e.g. 15&#10;30&#10;45&#10;60"
          />
        </FormGroup>
        <FormGroup>
          <Label>Wrong Sequence (one number per line)</Label>
          <Input
            type="textarea"
            value={wrongSequence.join("\n")}
            onChange={(e) => setWrongSequence(e.target.value.split("\n"))}
            rows={5}
            placeholder="e.g. 10&#10;25&#10;40&#10;55"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Adding..." : "Add"}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
